import { delay, http, HttpResponse, passthrough, PathParams } from "msw";
import { setupWorker } from "msw/browser";
import { movieHandlers } from "./mock_service_worker_handlers/";

// 单例模式
let started: Promise<any> | null = null;

// 确保生成 public/mockServiceWorker.js 文件: npx msw init public/
// 使用方式：await startMockServiceWorker();
export async function startMockServiceWorker() {
  if (started) {
    return started;
  }

  console.log("MSW starting");

  if (typeof window === "undefined") {
    console.warn("MSW not started because of no window object");
    return;
  }

  const worker = setupWorker(
    // http.all("*", ({ request }) => {
    //   console.log(`through service worker: ${request.method} ${request.url}`);
    //   return passthrough();
    // }),

    // http.get("https://github.com/octocat", ({ request, params, cookies }) => {
    //   return HttpResponse.json(
    //     {
    //       message: "Mocked response"
    //     },
    //     {
    //       status: 202,
    //       statusText: "Mocked status"
    //     }
    //   );
    // }),

    ...movieHandlers,

    http.get("*.js", () => passthrough()),
    http.get("*.svg", () => passthrough())
  );

  started = worker.start({
    // serviceWorker: {
    //   url: "/mockServiceWorker.js"
    // },
    onUnhandledRequest: "bypass"
    // onUnhandledRequest: "warn"
  });

  await started;

  console.log("MSW started");
  // console.log("handler counts = ", worker.listHandlers?.());
  window.navigator.serviceWorker.getRegistrations().then(console.log);
}
